export default "__VITE_PUBLIC_ASSET__a7ac4801__"